
export function displayError(error: string, opts?: { showReloadButton: boolean }) {
	const errorBox = document.getElementById("errorBox");
	if (!errorBox) {
		return;
	}

	if (!error) {
		errorBox.style.display = "none";
		return;
	}

	const reloadButton = document.getElementById("errorReloadButton");
	if (reloadButton) {
		reloadButton.style.display = opts?.showReloadButton ? "block" : "none";
	}

	errorBox.style.display = "block";
	errorBox.innerHTML = `<h3>Error</h3><p>${error}</p>`;
	errorBox.appendChild(reloadButton);

	initBackToLauncherShortcut();
}

// press L to go back to launcher.html
let shortcutInitialized = false;
function initBackToLauncherShortcut() {
	if (shortcutInitialized) {
		return;
	}
	shortcutInitialized = true;

	window.addEventListener("keydown", ({ key }) => {
		if (key === "l") {
			const parts = window.location.href.split("/").filter(part => !!part);
			parts[0] += "/"; // http(s)://
			if (parts.at(-1).includes("?") || parts.at(-1) === "index.html") {
				parts.pop();
			}

			window.location.href = [...parts, "launcher.html"].join("/");
		}
	});
}